import { CommonModule } from "@angular/common";
import { Component, Input } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";

@Component({
  selector: "app-detail-title-sa",
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: "./detail-title-sa.component.html",
})
export class DetailTitleSaComponent {
  @Input() titleKey!: string;
  @Input() reference!: string;
}
